import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-stroke": "currentColor",
  d: "M15.464 21H17a3 3 0 0 0 3-3v-7.5a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v5.161a1 1 0 0 0 1 1h.813a2 2 0 0 0 2-2v-.768a2 2 0 0 0-2-2H4.351",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-stroke": "currentColor",
  d: "M20 11.89h-1.843a2 2 0 0 0-2 2v.798a2 2 0 0 0 2 2H20",
  stroke: "currentColor",
  "stroke-width": "1.6"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }